import { FC } from 'react'
//components
import { useInViewFooter } from '../../../hooks/useInViewFooter'
import { useSendMessage } from '../../../hooks/useSendMessage'
import { inputState, isInViewFooterState, stepState } from '../../../states/messageState'
import { useSetRecoilState } from 'recoil'
import { FooterContent } from '../FooterContent'
import { Button } from '../../Button'

export const NotFoundInquiryCodeOrEmail: FC = () => {
  const { handleInViewFooter } = useInViewFooter()
  const { handleAddSenderParent } = useSendMessage()

  const setIsInViewFooter = useSetRecoilState(isInViewFooterState)
  const setCurrentStep = useSetRecoilState(stepState)
  const setInput = useSetRecoilState(inputState)

  /**保証番号かメールアドレスで再検索 */
  const handleRetryInputInquiryCodeOrEmail = async () => {
    await handleAddSenderParent('user', 'もう一度検索したい')
    setInput('')
    setIsInViewFooter(false)
    await handleAddSenderParent('bot', '保証番号かメールアドレスを入力して下さい。')
    handleInViewFooter()
    setCurrentStep('inputInquiryCodeOrEmail')
  }

  return (
    <FooterContent isWide={false}>
      <Button buttonType="outlined" onClick={handleRetryInputInquiryCodeOrEmail}>
        もう一度検索
      </Button>
    </FooterContent>
  )
}
